import { render } from "./TeamMembers.vue?vue&type=template&id=f095dc18"
import script from "./TeamMembers.vue?vue&type=script&lang=js"
export * from "./TeamMembers.vue?vue&type=script&lang=js"
script.render = render

export default script